module.exports = __webpack_public_path__ + "static/media/Happy2.7c07a82e.svg";